<template>
  <div class="order">
    <h3 class="title">鉴别结果</h3>
    <div>
      <span class="col"
        >
        <p>鉴定订单号:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.orderNo }}</span></span
      >
      <span class="col"
        >
        <p>鉴定号:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.OAID }}</span></span
      >
    </div>
    <div>
      <span class="col"
        >
        <p>用户手机号:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.userAccount }}</span></span
      >
      <span class="col"
        >
        <p>品类:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.kindName }}</span></span
      >
    </div>
    <div>
      <span class="col"
        >
        <p>品牌:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.brandName }}</span></span
      >
      <span class="col"
        >
        <p>系列:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.seriesName }}</span></span
      >
    </div>
    <div>
      <span class="col"
        >
        <p>订单金额:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.totalAmount / 100 }}</span></span
      >
      <span class="col"
        >
        <p>支付方式:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.payWay }}</span></span
      >
    </div>
    <div>
      <span class="col paystate"
        >
        <p>付款状态:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.payState == 0 ? "待付款" : "已付款" }}</span></span
      >
      <span class="col"
        >
        <p>鉴定时间:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.appraisalTime }}</span></span
      >
    </div>
    <div>
      <span class="col appresult"
        >
        <p>鉴定结果:</p>
        <span class="xin">*</span>
        <span class="text">{{ order.result == 0 ? "假 " : "真 " }} </span>
        <span class="grade"> {{`(得分${(order.grade * 100).toFixed()})`}}</span>
        </span
      >
      <span class="col desc"
        >
        <p>整体评价:</p>
        <span class="text"><span class="xin">*</span>{{ order.description }}</span></span
      >
    </div>
    <div class="imglist">
      <div v-for="(item,index) in SARecordList" :key="index">
        <img :src="item.image" alt="">
        <p>{{`${item.pointName}${item.pointName == '外观' ? '' : `(${(item.grade * 100).toFixed()})`}`}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrderDetail,
} from "@/common/api/appraisal.js";
export default {
  data() {
    return {
      // https://localhost/#/appraisal-result/1/AI202107271820259082
      // AI202107271840003218
      order: {
        orderNo: "",
        OAID: "",
        appraisalTime: "",
        kindName: "",
        brandName: "",
        seriesName: "",
        payState: "",
        result: "",
        description: "",
        totalAmount: "",
        grade: "",
        userAccount: "",
        payWay:''
      },
      SARecordList: [],
    };
  },
  mounted() {
    console.log('-------------');
    this.getDate()
  },
  methods: {
    async getDate () {
      console.log(this.$route.params.orderId);
      let res = await getOrderDetail({
        orderID: this.$route.params.orderId,
      })
      console.log(res);
      for (let item in this.order) {
        this.order[item ]= res[item];
      }
      this.SARecordList = res.SARecordList
      console.log(this.order);
    },
  }
};
</script>

<style lang="scss">
.order{
  display: flex;
  flex-direction: column;
  .paystate,.appresult {
    .text{
      color: #CBCB3F;
    }
    .grade {
      font-size: 0.6em;
    }
  }
  .title {
    text-align: center;
    margin-bottom: 20px;
  }
  .imglist {
    div {
      display: flex;
      flex-direction: column;
      width: 100px;
      height: 150px;
      img {
        width: 100px;
        height: 100px;
      }
      p {
        width: 100px;
        text-align: center;
      }
    }
  }
  div {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
    .desc {
      flex-direction: column;
    }
    .col {
      width: 300px;
      display: flex;
    }
    p {
      
      text-align: end;
      width: 130px;
      font-size: 0.6em;
      margin-right: 10px;
    }
    .xin {
      color: red;
    }
    .text {
      font-size: 0.6em;
    }
  }
}
</style>
